<h2 mat-dialog-title class="text-lg font-bold mb-1">Frecuencias</h2>
<mat-dialog-content class="modal-content">
  <!-- Tabla de Colaboradores -->
  <div>
    <table class="min-w-500 overflow-y-visible mat-elevation-z">
      <thead>
        <tr>
          <th>#</th>
          <th>Días</th>
          <th>Estado</th>
          <th>
            <button
              *ngIf="!openFormAdd"
              mat-icon-button
              color="primary"
              [disabled]="!(PERMISSIONS_FREQUENCIES.CREATE | hasPermission)"
              (click)="openFormAdd = true"
              matTooltip="Nuevo Registro"
            >
              <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              <span></span>
            </button>
            <button
              *ngIf="openFormAdd"
              mat-icon-button
              color="primary"
              (click)="openFormAdd = false; resetFormAddListCollaborators()"
              matTooltip="Cerrar"
            >
              <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngIf="openFormAdd == true"
          style="background: rgba(197, 191, 191, 0.2); border-radius: 12px"
        >
          <td></td>
          <td>
            <div class="col-span-2" style="text-align:center">
                <div class="checkbox-group">
                    <div *ngFor="let day of weekDays" class="checkbox-item">
                      <label>{{ day.day }}</label>
                      <mat-checkbox
                        color="primary"
                        [(ngModel)]="day.checked">
                      </mat-checkbox>
                    </div>
                  </div>
                  </div>
            <!-- <div class="col-span-2" style="text-align: center">
              <button
                mat-button
                color="primary"
                (click)="openFrecuencyModal('create')"
                matTooltip="Horario"
              >
                <mat-icon svgIcon="heroicons_solid:calendar"></mat-icon>
              </button>
            </div> -->
          </td>
          <td>
            <div class="col-span-2 flex justify-center items-center"></div>
          </td>
          <td>
            <div class="col-span-2" style="text-align: center">
              <button
                color="primary"
                mat-icon-button
                [disabled]="!(PERMISSIONS_FREQUENCIES.CREATE | hasPermission)"
                (click)="onAddToListDeliveryTimes()"
              >
                <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
              </button>
            </div>
          </td>
        </tr>
        <tr *ngFor="let item of listCollaboratorsAdd; let i = index">
          <td valign="center">{{ i + 1 }}</td>
          <td>
            <div class="col-span-2" style="text-align:center">
                <div class="checkbox-group">
                    <div *ngFor="let day of weekDays" class="checkbox-item">
                      <label>{{ day.day }}</label>
                      <mat-checkbox  [disabled]="!item.isEditMode" 
                      color="primary"
                      [checked]="item.days.includes(day.value)" 
                      (change)="onDaySelectionChange($event, day.value, item)" >
                    </mat-checkbox>
                    </div>
                  </div>
              </div>
            <!-- <div class="col-span-2" style="text-align: center">
              <button
                mat-button
                color="primary"
                (click)="openFrecuencyModal('edit', item)"
                matTooltip="Horario"
                [disabled]="!item.isEditMode"
              >
                <mat-icon
                  svgIcon="heroicons_solid:calendar"
                  matBadge="{{ item.days.length }}"
                  matBadgeColor="primary"
                  matBadgeSize="small"
                ></mat-icon>
              </button>
            </div> -->
          </td>
          <td>
            <div class="col-span-2 flex justify-center items-center">
              <mat-slide-toggle
                [checked]="item.statusId === 1"
                (change)="onStatusChange($event.checked, item)"
                color="primary"
                [disabled]="!item.isEditMode"
              >
              </mat-slide-toggle>
            </div>
          </td>
          <td>
            <div class="col-span-2" style="text-align: center">
              <button
                color="primary"
                mat-icon-button
                [disabled]="!(PERMISSIONS_FREQUENCIES.UPDATE | hasPermission)"
                (click)="onUpdateDeliveryTime(item, i)"
                *ngIf="!item.isEditMode"
              >
                <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
              </button>
              <button
                color="primary"
                mat-icon-button
                [disabled]="!(PERMISSIONS_FREQUENCIES.UPDATE | hasPermission)"
                (click)="onSaveDeliveryTime(item, i)"
                *ngIf="item.isEditMode"
              >
                <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
              </button>
              <button
                color="warn"
                mat-icon-button
                [disabled]="!(PERMISSIONS_FREQUENCIES.DELETE | hasPermission)"
                (click)="onDeleteDeliveryTime(item, i)"
              >
                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
</mat-dialog-actions>
